import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';

import { UploadImageApi } from './apis/upload-api';
import { UploadImageApiImpl } from './apis/impls/upload-api';

export const uploadImageContainer = new ContainerModule((bind) => {
  bind(UploadImageApi).to(UploadImageApiImpl);
});
